export default __webpack_public_path__ + "static/media/a5.9321cf52.png";